module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__canadian--container"
  }, [_c('p', [_vm._v("\n    If you’d like to find an Authorized Compustar dealer near you in Canada, please contact one of our regional distributors listed below.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Western Canadian & Ontario Customers")]), _c('br'), _vm._v("\n    Please contact Staub Electronics, LTD."), _c('br'), _vm._v("\n    Toll-Free – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "tel:+18884702211"
    }
  }, [_vm._v("1(888)470-2211")]), _c('br'), _vm._v("\n    Website – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "https://www.staub.ca/",
      "target": "_blank"
    }
  }, [_vm._v("www.Staub.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Eastern Canadian Customers")]), _c('br'), _vm._v("\n    Please contact Robert Thibert, Inc."), _c('br'), _vm._v("\n    Toll-Free – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "tel:+18002681062"
    }
  }, [_vm._v("1(800)268-1062")]), _c('br'), _vm._v("\n    Website – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "http://www.rthibert.com/en-ca/",
      "target": "_blank"
    }
  }, [_vm._v("www.RThibert.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5778e4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/CanadianContact.vue
// module id = 435
// module chunks = 1